module.exports = __webpack_public_path__ + "static/img/10.20c84d5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/12/sp/10.png
// module id = sx1c
// module chunks = 0